import { render } from "./home-instructor.vue?vue&type=template&id=15366168"
import script from "./home-instructor.vue?vue&type=script&lang=js"
export * from "./home-instructor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__